class CollectionInfiniteScroll {
  constructor() {
    this.isLoading = false;
    this.hasMorePages = true;
    this.threshold = 700; // Distance from bottom to trigger load (in pixels)
    this.scrollHandlerBound = false;
    this.loadMoreButtonBound = false;

    this.elements = {
      productGrid: document.getElementById('product-grid'),
      loadedCount: document.querySelector('.loaded_count'),
      totalCount: document.querySelector('.total_count'),
      progressBar: document.querySelector('.load-more_progress-bar .progress-value'),
      spinner: document.querySelector('.load-more_spinner'),
      loadMoreBtn: document.querySelector('.load-more_btn'),
      progressBarContainer: document.querySelector('.load-more_progress-bar')
    };
    this.mode = this.elements.productGrid?.dataset.loadingBehavior || 'infinite_scroll';

    this.init();
  }

  init() {
    if (!this.elements.productGrid) {
      console.warn('Product grid not found. Infinite scroll not initialized.');
      return;
    }

    this.updateInitialCounts();
    this.checkInitialState();

    if (this.mode === 'infinite_scroll') {
      this.bindScrollEvent();
    } else if (this.mode === 'load_more') {
      this.bindLoadMoreButton();
    }

    this.hideLoadMoreButton();
    this.changeYotpoStarColor();
  }

  refresh() {
    this.elements = {
      productGrid: document.getElementById('product-grid'),
      loadedCount: document.querySelector('.loaded_count'),
      totalCount: document.querySelector('.total_count'),
      progressBar: document.querySelector('.load-more_progress-bar .progress-value'),
      spinner: document.querySelector('.load-more_spinner'),
      loadMoreBtn: document.querySelector('.load-more_btn'),
      progressBarContainer: document.querySelector('.load-more_progress-bar')
    };
    this.mode = this.elements.productGrid?.dataset.loadingBehavior || 'infinite_scroll';

    if (!this.elements.productGrid) {
      return;
    }

    this.updateInitialCounts();
    this.checkInitialState();

    if (this.mode === 'infinite_scroll') {
      this.bindScrollEvent();
    } else if (this.mode === 'load_more') {
      this.bindLoadMoreButton();
    }

    this.hideLoadMoreButton();
  }

  changeYotpoStarColor() {
    const updateStarColors = (node, newColor) => {
      const isTargetRgba = (val) => /^rgba\(\d{1,3},\d{1,3},\d{1,3},1\)$/i.test(val.trim());

      const stops = node.querySelectorAll("stop");
      stops.forEach(stop => {
        const color = stop.getAttribute("stop-color");
        if (color && isTargetRgba(color)) {
          stop.setAttribute("stop-color", newColor);
        }
      });

      const paths = node.querySelectorAll("path");
      paths.forEach(path => {
        const stroke = path.getAttribute("stroke");
        if (stroke && isTargetRgba(stroke)) {
          path.setAttribute("stroke", newColor);
        }
      });
    };


    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches('.yotpo-widget-instance, .yotpo-widget-instance *')) {
            const newColor = node.parentElement.dataset.starColor || node.dataset.starColor;
            updateStarColors(node, newColor);
          }
        });
      });
    });

    observer.observe(document.querySelector('.product-grid-container'), {
      childList: true,
      subtree: true,
    });

    document.querySelectorAll('.yotpo-widget-instance').forEach(widget => {
      const newColor = widget.dataset.starColor;
      updateStarColors(widget, newColor);
    });
  }


  updateInitialCounts() {
    const productsOnPage = this.elements.productGrid.querySelectorAll('.grid__item.product__item').length;
    const totalProducts = parseInt(this.elements.totalCount?.innerHTML || '0');

    if (this.elements.loadedCount) {
      this.elements.loadedCount.innerHTML = productsOnPage;
    }

    this.updateProgressBar(productsOnPage, totalProducts);
  }

  updateProgressBar(loadedCount, totalCount) {
    if (this.elements.progressBar && totalCount > 0) {
      const percentage = ((loadedCount / totalCount) * 100);
      this.elements.progressBar.style.width = `${percentage}%`;
    }
  }

  getNextUrl() {
    return this.elements.productGrid?.dataset.nextUrl || this.elements.productGrid?.getAttribute('data-next-url') || '';
  }

  hideLoadMoreButton() {
    if (!this.elements.loadMoreBtn) {
      return;
    }

    const hasNextUrl = !!this.getNextUrl();
    const productsPerPage = parseInt(this.elements.productGrid?.dataset.productsPerPage || this.elements.productGrid?.getAttribute('data-products-per-page') || '0', 10);
    const totalProducts = parseInt(this.elements.totalCount?.innerHTML || '0', 10);
    const shouldShowButton = this.mode === 'load_more' && (this.hasMorePages || hasNextUrl) && totalProducts > productsPerPage;
    this.elements.loadMoreBtn.style.display = shouldShowButton ? 'inline-flex' : 'none';
  }

  showSpinner() {
    if (this.elements.spinner) {
      this.elements.spinner.style.display = 'block';
    }
    if (this.elements.progressBarContainer) {
      this.elements.progressBarContainer.style.display = 'none';
    }
  }

  hideSpinner() {
    if (this.elements.spinner) {
      this.elements.spinner.style.display = 'none';
    }
    if (this.elements.progressBarContainer) {
      this.elements.progressBarContainer.style.display = 'block';
    }
  }

  bindScrollEvent() {
    if (this.scrollHandlerBound) {
      return;
    }

    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.checkScrollPosition();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    this.scrollHandlerBound = true;
  }

  bindLoadMoreButton() {
    if (!this.elements.loadMoreBtn || this.loadMoreButtonBound) {
      return;
    }

    this.elements.loadMoreBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.checkScrollPosition();
    });
    this.loadMoreButtonBound = true;
  }

  checkScrollPosition() {
    if (this.isLoading || !this.hasMorePages) {
      return;
    }

    if (this.mode === 'infinite_scroll') {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Use a smaller threshold on mobile viewports; even smaller in portrait mode
      let threshold = this.threshold;
      try {
        if (window.matchMedia) {
          const isMobile = window.matchMedia('(max-width: 767px)').matches;
          const isPortrait = window.matchMedia('(orientation: portrait)').matches;
          if (isMobile && isPortrait) {
            threshold = 600;
          }
        }
      } catch (e) {
        // Fallback: basic touch-capable + orientation heuristic
        const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isTouch && isPortrait) {
          threshold = 600;
        }
      }

      // Check if we're within the threshold distance from the bottom
      if (scrollTop + windowHeight >= documentHeight - threshold) {
        this.loadMoreProducts();
      }
      return;
    }

    if (this.mode === 'load_more') {
      this.loadMoreProducts();
    }
  }

  checkInitialState() {
    const nextUrl = this.getNextUrl();

    if (!nextUrl && this.mode === 'infinite_scroll') {
      this.hasMorePages = false;
      console.log('No more pages to load');
      return;
    }

    if (!nextUrl && this.mode === 'load_more' && !this.elements.loadMoreBtn) {
      this.hasMorePages = false;
      return;
    }

    this.hasMorePages = true;
  }

  async getNextPage(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.text();
    } catch (error) {
      console.error('Error fetching next page:', error);
      throw error;
    }
  }

  async loadMoreProducts() {
    if (this.isLoading || !this.hasMorePages) {
      return;
    }

    const nextUrl = this.elements.productGrid?.dataset.nextUrl;
    if (!nextUrl) {
      this.hasMorePages = false;
      return;
    }

    this.isLoading = true;
    this.showSpinner();

    try {
      const nextPageHtml = await this.getNextPage(nextUrl);
      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPageHtml, 'text/html');

      const newProductGrid = nextPageDoc.getElementById('product-grid');
      if (!newProductGrid) {
        throw new Error('Product grid not found in next page');
      }

      const newProducts = newProductGrid.getElementsByClassName('grid__item');
      const newNextUrl = newProductGrid.dataset.nextUrl;

      // Update the next URL for future loads
      this.elements.productGrid.setAttribute('data-next-url', newNextUrl || '');

      // If no more pages, mark as complete
      if (!newNextUrl) {
        this.hasMorePages = false;
      }

      // Append new products to the grid
      this.appendProducts(newProducts);
      this.updateCounts();
      this.hideLoadMoreButton();

      console.log(`Loaded ${newProducts.length} more products. Has more pages: ${this.hasMorePages}`);

      if (window.yotpoWidgetsContainer) {
        window.yotpoWidgetsContainer.initWidgets()
      }

    } catch (error) {
      console.error('Error loading more products:', error);
      // On error, we can retry or show an error message
      setTimeout(() => {
        this.isLoading = false;
      }, 2000); // Wait 2 seconds before allowing retry
      return;
    }

    this.hideSpinner();
    this.isLoading = false;
  }

  appendProducts(newProducts) {
    for (let i = 0; i < newProducts.length; i++) {
      const productClone = newProducts[i].cloneNode(true);
      this.elements.productGrid.appendChild(productClone);
    }
  }

  updateCounts() {
    const totalLoadedProducts = this.elements.productGrid.querySelectorAll('.grid__item.product__item').length;
    const totalProducts = parseInt(this.elements.totalCount?.innerHTML || '0');

    if (this.elements.loadedCount) {
      this.elements.loadedCount.innerHTML = totalLoadedProducts;
    }

    this.updateProgressBar(totalLoadedProducts, totalProducts);

    // If all products are loaded, hide the progress bar
    if (totalLoadedProducts >= totalProducts || !this.hasMorePages) {
      if (this.elements.progressBarContainer) {
        this.elements.progressBarContainer.style.display = 'none';
      }
    }
  }

  // Public method to manually trigger load (useful for testing)
  triggerLoad() {
    if (!this.isLoading && this.hasMorePages) {
      this.loadMoreProducts();
    }
  }

  // Public method to destroy the infinite scroll (cleanup)
  destroy() {
    window.removeEventListener('scroll', this.checkScrollPosition);
  }
}

// Initialize infinite scroll when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize if we're on a collection page with products
  if (document.getElementById('product-grid')) {
    window.collectionInfiniteScroll = new CollectionInfiniteScroll();
  }
});

// Export for potential use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = CollectionInfiniteScroll;
}
